import React, { useEffect, useState } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';

import logo from '../assets/images/HAiReport_color_vertical.svg';
import bg from '../assets/images/bg_wave.png';

import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { useTheme } from '@mui/material/styles';

import useUser from '../hook/useUser';
import useGlobalStatus from '../hook/useGlobalStatus';
import useReportStatus from '../hook/useReportStatus';

import { FullImage } from '../components/CustomComp';

import { MEDIA_DATA, currentMediaType } from '../constants/mediaData';


const OutBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center'
}))

const ButtonStyle = styled(Box)(({ theme }) => ({
  width: '250px',
  margin: '0 12px',
  padding: '12px 0',
  textAlign: 'center',
  backgroundColor: '#fff',
  borderRadius: '4px',
  transition: 'all .5s',
  cursor: 'pointer',
}))

const MediaMenu = ({ media }) => {
  const theme = useTheme();
  const history = useHistory();
  const { userData, setUserData, setAuthStatusMsg, setAlertMsg } = useUser();
  const { setCurrentActiveData, setEntryPath } = useGlobalStatus();
  const { setSendList } = useReportStatus();

  useEffect(() => {
    setSendList([]);
  }, [])

  return (
    <>
      {
        <Box
          sx={{
            position: 'absolute',
            width: '100%',
            height: '100%',
            background: `url(${bg}) no-repeat center bottom`,
            borderTop: `8px solid ${theme.palette.system.w500}`,
            boxSizing: 'border-box'
          }}
        >
          <Box
            sx={{
              margin: '8% auto 0',
              borderRadius: '8px',
              textAlign: 'center'
            }}
          >
            <Box sx={{ width: '200px', margin: '0 auto 40px' }}>
              <FullImage src={logo} alt="HAi Report" />
            </Box>

            <OutBox>
              {currentMediaType.map((el, index) => {
                return (
                  <ButtonStyle
                    key={`${index}_${MEDIA_DATA[el].media}`}
                    sx={{
                      color: MEDIA_DATA[el].color,
                      fontSize: theme.typography.h4,
                      border: `1px solid ${MEDIA_DATA[el].color}`,
                      '&:hover': {
                        color: '#fff',
                        backgroundColor: MEDIA_DATA[el].color,
                        borderColor: MEDIA_DATA[el].color,
                      }
                    }}
                    onClick={() => {
                      history.push(MEDIA_DATA[el].sendListUrl);
                      setCurrentActiveData(false);
                      setEntryPath(MEDIA_DATA[el].entryPath);
                    }}
                  >
                    {MEDIA_DATA[el].media}
                  </ButtonStyle>
                )
              })}
            </OutBox>
          </Box>
        </Box>
      }
    </>
  );
}

export default MediaMenu;